import { render, staticRenderFns } from "./SummaryVisaVisitRevenuePage.vue?vue&type=template&id=9446466c&scoped=true&"
import script from "./SummaryVisaVisitRevenuePage.vue?vue&type=script&lang=js&"
export * from "./SummaryVisaVisitRevenuePage.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVisaVisitRevenuePage.vue?vue&type=style&index=0&id=9446466c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9446466c",
  null
  
)

export default component.exports